import { Snackbar } from "@material-ui/core";
import update from "immutability-helper";
import Blob from "blob";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { getAllSuppliers } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import PurchaseService from "../../services/PurchaseOrder";
import ProductService from "../../services/ProductService";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CurrencyService from "../../services/CurrencyService";
import UtilsFormule from "../../utils/UtilsFormule";
import { useNavigate } from "react-router-dom";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));
function getSteps() {
  return ["Ajouter les produits ", "Créer un achat   ", "Finaliser"];
}

const AddPurchaseOrder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const suppliers = useSelector((state) => state.staff.suppliers.Societe);
  const [availableProducts, setAvailableProducts] = useState([]);

  const [factureReference, setFactureReference] = useState("");

  const [supplierId, setSupplierId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [tva, setTva] = useState(0);
  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [discountType, setDiscountType] = useState("pourcentage");

  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [modeProduct, setModeProduct] = useState(null);

  const [
    purchaseOrderPricePurchasingWithoutDiscount,
    setPurchaseOrderPricePurchasingWithoutDiscount,
  ] = useState(0);
  const [
    purchaseOrderPricePurchasingWithDiscount,
    setPurchaseOrderPricePurchasingWithDiscount,
  ] = useState(0);
  const [ordreTitle, setOrdreTitle] = useState("");
  const [ordreRef, setOrdreRef] = useState("");
  const [ordreDateLimite, setOrdreDateLimite] = useState("any");
  const [ordreUrl, setOrdreUrl] = useState("any");
  const [bdcUrl, setBDCUrl] = useState("any");
  const [ordreDesignation, setOrdreDesignation] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);
  const [allSuppliers, setAllSuppliers] = React.useState([{}]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Choisir...");
  const [availableLot, setAvailableLot] = useState([]);
  const [allLot, setAllLot] = useState([{ value: 0, label: "Aucun lot" }]);
  const [modeProductSelectPlaceHolder, setModeProductSelectPlaceHolder] =
    useState("Choisir...");
  const [createPOFromFacture, setCreatePOFromFacture] = useState(false);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");
  const [allModeProduct, setAllModeProduct] = React.useState([
    { value: 1, label: "Local" },
    { value: 2, label: "Import" },
  ]);
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [montantDevis, setMontantDevis] = useState(0);
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);

  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [tauxChange, setTauxChange] = useState(0);
  const [labelDevise, setLabelDevise] = useState("Prix en DNT");
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [devisPriceTt, setDevisPriceTt] = useState(0);
  const [devisPriceHt, setDevisPriceHt] = useState(0);

  const [allCurrencies, setAllCurrencies] = React.useState([
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);
  const [initialPriceHTC, setInitialPriceHTC] = useState(0);
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [priceTT, setPriceTT] = useState(0);
  const [discountFinal, setDiscountFinal] = useState(0);
  const [idLot, setIdLot] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const steps = getSteps();

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  useEffect(() => {
    dispatch(getAllSuppliers());
    ProductService.getAllProductsOnPurshase(getCurrentUserId(), 1).then(
      (response) => {
        setAvailableProducts(response.data["Allproducts"]);
      }
    );

    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    ).then((response) => {
      setAvailableLot(response.data);
    });
  }, []);

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);

  useEffect(() => {
    availableProducts &&
      availableProducts.map((element) => {
        let exist = false;
        if (allProducts.length !== 0) {
          for (let index = 0; index < allProducts.length; index++) {
            if (allProducts[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        let codeProduct = "*";
        if (element.productCode !== undefined) {
          codeProduct = element.productCode;
        }
        let barCodeProduct = "*";
        if (element.barcode) {
          barCodeProduct = element.barcode;
        }
        let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
        if (element?.id !== undefined && exist === false) {
          setAllProducts((oldArray) => [
            ...oldArray,
            { value: element.id, label: label },
          ]);
        }
      });
  }, [availableProducts]);
  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);

  useEffect(() => {
    if (ordreDateLimite === ":59") {
      setOrdreDateLimite("any");
    }
  }, [ordreDateLimite]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeOrdreTitleHandler = (event) => {
    setOrdreTitle(event.target.value);
  };

  // const onChangeOrdreUrlHandler = (event) => {
  //   setOrdreUrl(event.target.value);
  // };
  // const onChangeBDCUrlHandler = (event) => {
  //   setBDCUrl(event.target.value);
  // };
  const onChangeOrdreDesignationHandler = (event) => {
    setOrdreDesignation(event.target.value);
  };
  // const onChangeLimitDateHandler = (event) => {
  //   setOrdreDateLimite(event.target.value.concat(":59"));
  // };

  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setLabelDevise("Prix U en DNT");
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };

  const onChangePromotionHandler = (event) => {
    setPromotionPercentage(event.target.value);
  };
  const onChangeDiscountHandler = (event) => {
    setDiscount(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(event.target.value, discountType);
  };

  const onChangeDiscountTypeHandler = (event) => {
    setDiscountType(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(discount, event.target.value);
  };
  const CalculateNewPurchasingPriceAfterDiscount = (discount, discountType) => {
    let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
      productTableData,
      discount,
      discountType
    );
    console.log("result discount", result);
    let sumPromotionHt = result[1];
    let sumPromotionTt = result[2];
    let sumPriceHt = result[3];

    setDevisPriceHt(sumPromotionHt);
    setDevisPriceTt(sumPromotionTt);
    setInitialPriceHTC(sumPriceHt);
    setBuyingPrice(sumPromotionHt);
    setPriceTT(sumPromotionTt);
    setDiscountFinal(result[4]);
  };

  // const onChangeFactureReferenceHandler = (event) => {
  //   setFactureReference(event.target.value);
  // };

  // const onDeleteProduct = (id) => {
  //   setProductTableData(productTableData.filter((item) => item.id !== id));
  //   setProductMapById(productMapById.filter((item) => item.id !== id));
  // };

  // const onGetFactureCByReference = () => {
  //   //here
  //   if (factureReference === "") {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText("Erreur : Aucune réference");
  //     setCreatePOFromFacture(false);
  //     setProductMapById([]);
  //     setProductTableData([]);
  //   } else {
  //     PurchaseService.getFactureByRef(factureReference)
  //       .then((response) => {
  //         if (Object.keys(response.data)[0] == "success") {
  //           if (response.data.success.state == 0) {
  //             setProductMapById([]);
  //             setProductTableData([]);
  //             response.data.success.purchases.forEach((element) => {
  //               setProductMapById((previoustate) => [
  //                 ...previoustate,
  //                 {
  //                   productRef: element.product.name,
  //                   id: element.product.id,
  //                   unitPrice: element.initialPriceHtc,
  //                   quantity: element.quantity,
  //                   tva: element.tva,
  //                   htPrice: element.initialPriceHtc * element.quantity,
  //                   ttPrice: element.priceTt,
  //                   promotionType: "pourcentage",
  //                   promotion:
  //                     Math.round(element.promotionPercentage * 100) / 100,
  //                   BuyingPrice: Math.round(element.buyinfPrice * 100) / 100,
  //                 },
  //               ]);

  //               setProductTableData((previoustate) => [
  //                 ...previoustate,
  //                 {
  //                   productRef: element.product.name,
  //                   id: element.product.id,
  //                   unitPrice: element.initialPriceHtc,
  //                   quantity: element.quantity,
  //                   tva: element.tva,
  //                   htPrice: element.initialPriceHtc * element.quantity,
  //                   ttPrice: element.priceTt,
  //                   promotionType: "pourcentage",
  //                   promotion:
  //                     Math.round(element.promotionPercentage * 100) / 100,
  //                   BuyingPrice: Math.round(element.buyinfPrice * 100) / 100,
  //                 },
  //               ]);
  //             });

  //             setCreatePOFromFacture(true);
  //             setDiscountType("pourcentage");
  //             setDiscount(response.data.success.discountPercentage);
  //             setSupplierId(response.data.success.supplierId);
  //             setSupplierSelectPlaceHolder(response.data.success.supplierTitle);
  //             setPurchaseOrderPricePurchasingWithDiscount(
  //               response.data.success.buyingPrice
  //             );
  //           } else {
  //             setOpenInfoAlert(true);
  //             setInfoAlertText("ce facture  est deja confirmé");
  //           }
  //         } else if (Object.keys(response.data)[0] == "empty") {
  //           setOpenInfoAlert(true);
  //           setInfoAlertText("info : aucun facture  avec ce réference   ");
  //         }
  //       })
  //       .catch(() => {
  //         setOpenErrorAlert(true);
  //         setErrorAlertText("Erreur : il ya un probléme de connection");
  //       });
  //   }
  // };

  const handleNext = () => {
    if (activeStep === 0) {
      let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setDevisPriceHt(sumPromotionHt);
      setDevisPriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
    }
    if (activeStep === 0 && productTableData.length > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun produit ");
    } else if (activeStep === 1 && ordreTitle === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de titre est vide ");
    } else if (activeStep === 1 && supplierId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun fournisseur ");
    } else if (activeStep === 1 && ordreDesignation === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun description ");
    } else if (activeStep === 1) {
      setProductTableData(
        UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
          productTableData,
          discountFinal
        )
      );
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 2) {
      let purchaseOrderModel = {};

      if (createPOFromFacture === false) {
        purchaseOrderModel = {
          buyingPrice: buyingPrice,
          refFacture: "",
          description: ordreDesignation,
          discountPercentage: discountFinal,
          idSupplier: supplierId,
          idUser: getCurrentUserId(),
          initialPriceHtc: initialPriceHTC,
          note: ordreDesignation,
          priceHT: devisPriceHt,
          priceTT: priceTT,
          purchases: UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
            productTableData,
            discountFinal
          ),
          title: ordreTitle,
          ordreDate: "any",
        };
      } else {
        purchaseOrderModel = {
          description: ordreDesignation,
          refFacture: factureReference,
          idUser: getCurrentUserId(),
          note: ordreDesignation,
          path: "any",
          title: ordreTitle,
          ordreDate: "any",
        };
      }
      console.log("purchaseOrderModel :", JSON.stringify(purchaseOrderModel));
      onSendPOToBackendSystem(purchaseOrderModel);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setTimeout(() => {
      navigate(`/productSell`);
    }, 2000);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const onSendPOToBackendSystem = (purchaseOrderModel) => {
    PurchaseService.addOrderPurchaseToVRWarehouse(purchaseOrderModel)
      .then((response) => {
        console.log("response", response);
        if (Object.keys(response.data)[0] === "PurchaseOrder") {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/allPurchaseOrders`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme au niveau de serveur");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  const onChangeSelectedMode = (selectedOptionn) => {
    setSelectedOptionMode(selectedOptionn.value);
    setModeProduct(selectedOptionn.value);
    setModeProductSelectPlaceHolder(selectedOptionn.label);
  };
  const onHandleClickTauxChange = () => {
    if (deviseChoosen !== null) {
      getCurrencyRate(deviseChoosen);
    }
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        console.log("response");
        setTauxChange(response.data);

        setLabelDevise(
          "TAUX D'ECH (" +
            response.data.toLocaleString(undefined, {
              maximumFractionDigits: 3,
            }) +
            ") ESTI DNT (" +
            (unitPrice * response.data).toLocaleString(undefined, {
              maximumFractionDigits: 3,
            }) +
            " )"
        );
      });
    } catch (error) {
      console.log("error currency", error);
    }
  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    // setProductId(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  const devise = () => {
    if (modeProduct === 2) {
      return (
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Devise</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOptionDevis}
                  onChange={onChangeSelectedDevis}
                  options={allCurrencies}
                  placeholder={deviseSelectPlaceHolder}
                />
              </div>
            </div>
            {calculDevis()}
          </div>
        </div>
      );
    }
  };
  const onChangeMontantDevisHandler = (event) => {
    setMontantDevis(0);
    setMontantDevis(event.target.value);
  };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const calculDevis = () => {
    return (
      <div className="col-sm-6">
        <div className="input-group">
          <label>{labelDeviseTest()}</label>
          <div className="input-group-prepend" style={{ width: "89%" }}>
            <input
              onChange={onChangeMontantDevisHandler}
              type="number"
              min="0"
              id="montantDevise"
              className="form-control"
            />
          </div>
          <div className=" input-group-append">
            <button
              onClick={onHandleClickTauxChange}
              type="button"
              class="btn btn-dark"
            >
              <i class="fas fa-solid fa-dollar-sign"></i>{" "}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  const columns = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "buyingPriceU",
      text: "Prix U.A",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Remise",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "idProduct",
      text: "Supprimer",
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            {createPOFromFacture === false && (
              <div>
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Choisir un produit</label>

                      <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedProduct}
                        options={allProducts}
                        placeholder={productSelectPlaceHolder}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Prix.U.H.T</label>
                      <input
                        value={unitPrice}
                        onChange={onChangeUnitPriceHandler}
                        type="number"
                        min="0"
                        id="unitPrice"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">Quantité</label>
                      <input
                        onChange={onChangeQuantityHandler}
                        value={quantity}
                        type="number"
                        min="0"
                        id="quantity"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">TVA</label>
                      <input
                        value={tva}
                        onChange={onChangeTvaHandler}
                        type="number"
                        min="0"
                        id="tva"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Produit local/import</label>
                      <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOptionMode}
                        onChange={onChangeSelectedMode}
                        options={allModeProduct}
                        placeholder={modeProductSelectPlaceHolder}
                      />
                    </div>
                  </div>
                  {devise()}
                </div>
                <div class="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Choisir le type de promotion</label>
                      <select
                        value={promotionType}
                        onChange={(e) => setPromotionType(e.target.value)}
                        className="form-control select2"
                        style={{ width: "100%" }}
                      >
                        <option
                          key={1}
                          value={"pourcentage"}
                          selected="selected"
                        >
                          Pourcentage
                        </option>
                        <option key={2} value={"montant"}>
                          Montant
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">Promotion</label>
                      <input
                        value={promotionPercentage}
                        onChange={onChangePromotionHandler}
                        type="number"
                        min="0"
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>Choisir un Lot</label>

                      <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOptionLot}
                        onChange={onChangeSelectedLot}
                        options={allLot}
                        placeholder={lotSelectPlaceHolder}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-12  text-center">
                    <button
                      style={{ marginBottom: 20 }}
                      className="btn btn-dark"
                      onClick={onAddProductToList}
                    >
                      <i class="fas fa-plus"></i>
                      Liste des achats{" "}
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Titre</label>
                  <input
                    value={ordreTitle}
                    required="required"
                    onChange={onChangeOrdreTitleHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Saisir..."
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Choisir le Fournisseur{" "}
                  </label>
                  <Select
                    isDisabled={createPOFromFacture}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={supplierSelectedOption}
                    onChange={onChangeSelectedSupplier}
                    options={allSuppliers}
                    placeholder={supplierSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir le type de Remise </label>
                  <select
                    disabled={createPOFromFacture}
                    value={discountType}
                    onChange={onChangeDiscountTypeHandler}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    <option key={1} value={"pourcentage"} selected="selected">
                      Pourcentage
                    </option>
                    <option key={2} value={"montant"}>
                      Montant
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Remise</label>
                  <input
                    disabled={createPOFromFacture}
                    value={discount}
                    onChange={onChangeDiscountHandler}
                    type="number"
                    min="0"
                    id="inputRemiseClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="inputDescription">Note</label>
                  <textarea
                    value={ordreDesignation}
                    placeholder="Saisir..."
                    onChange={onChangeOrdreDesignationHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row bg-light">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Ht </label>
                  <input
                    value={devisPriceHt}
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Tt </label>
                  <input
                    value={discount !== 0 ? devisPriceTt : devisPriceTt}
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-12"></div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.id === productId) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableProducts.forEach((element) => {
        if (element.id === productId) {
          productRef = element.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (quantity === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité du produit doit être supérieur à zéro "
      );
    } else if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun produit ");
    } else if (unitPrice === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le prix unitaire  doit etre sup a zero");
    } else {
      let result = UtilsFormule.CalculatePromotionProductPurchase(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      let promotionAmountOrPersentage = result[0];
      let buyingPriceU = result[1];
      let promotionpercent = result[2];
      let ttPrice = result[3];
      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            buyingPriceU: buyingPriceU,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            buyingPriceU: buyingPriceU,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.buyingPriceU = buyingPriceU;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = ttPrice;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le prix unitaire du produit :  " +
              productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le type de promotion du produit :  " +
              productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la promotion du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la quantité du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le tva du produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section className="content ">
        <div className="container-fluid">
          <div className="row ">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper
                      alternativeLabel
                      activeStep={activeStep}
                      style={{ marginTop: 4 }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>
                <div>
                  {activeStep === steps.length ? (
                    <div class="card-body">
                      <div class="row" style={{ marginTop: 2 }}></div>
                      Toutes les étape ont été complétées avec succès
                      <button
                        className="btn btn-dark float-right"
                        onClick={handleReset}
                      >
                        Réinitialiser
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div class="card-body">{getStepContent(activeStep)}</div>
                      <div class="card-footer" style={{ marginTop: "1%" }}>
                        <button
                          disabled={activeStep === 0}
                          className="btn btn-light"
                          onClick={handleBack}
                        >
                          Précédent
                        </button>

                        <button class="btn btn-dark" onClick={handleNext}>
                          {activeStep === steps.length - 1
                            ? "Terminer"
                            : "Suivant"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddPurchaseOrder;
